<template>
  <div class="announcement-wrapper">
    <InfoList
      :data="announcementList"
      :visited="visitedAnnouncement"
      :busy="busy"
      @load="getAnnouncementList"
      @to="goPage"
    />
    <LoadMoreButton :finished="finished" :loading="loading" @click="getAnnouncementList" />
  </div>
</template>

<script>
import InfoList from '@/components/common/info/InfoList.vue'
import LoadMoreButton from '@/components/common/LoadMoreButton.vue'

const DATE_RANGE = 10
export default {
  name: 'Announcement',
  components: { InfoList, LoadMoreButton },
  data() {
    return {
      announcementList: [],
      visitedAnnouncement: [],
      loading: false,
      finished: false,
      pageNum: 0,
      startDate: this.$dayjs().subtract(DATE_RANGE, 'day').format('YYYY-MM-DD'),
      endDate: this.$dayjs().format('YYYY-MM-DD'),
      deactivated: false
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    busy() {
      return this.loading || this.finished || this.deactivated
    }
  },
  mounted() {
    this.initVisited()
  },
  activated() {
    this.deactivated = false
  },
  deactivated() {
    this.deactivated = true
  },
  methods: {
    async getAnnouncementList() {
      if (this.busy) return

      this.loading = true

      this.pageNum++

      let url = this.$api.rm[this.market] + '/notice/multiLanguage/filter'
      if (this.market === 'hs') {
        url = this.$api.sdk[this.market] + '/notice/filter'
      }
      // const res = await this.$post(this.$api.sdk[this.market] + '/notice/filter', {
      const res = await this.$post(url, {
        // startDate: this.startDate,
        endDate: this.endDate,
        pageNum: this.pageNum,
        pageSize: 20,
        symbols: [this.symbol]
      })

      const list = res.body?.list ?? []
      const isLastPage = res.body?.isLastPage ?? true

      if (isLastPage) {
        this.finished = true
      }

      // if (!list.length) {
      //   this.finished = true
      //   return
      // }

      // if (isLastPage) {
      //   this.pageNum = 0
      //   this.startDate = this.$dayjs(this.startDate)
      //     .subtract(DATE_RANGE + 1, 'day')
      //     .format('YYYY-MM-DD')
      //   this.endDate = this.$dayjs(this.endDate)
      //     .subtract(DATE_RANGE + 1, 'day')
      //     .format('YYYY-MM-DD')
      // }

      this.announcementList = [...this.announcementList, ...list]
      this.loading = false
    },
    goPage(item) {
      const { noticeId, typeName, subTypeName, time } = item

      this.saveVisited(noticeId)
      localStorage.setItem('announcement-detail', JSON.stringify(item))
      this.$router.push({
        path: '/announcement/details',
        query: {
          id: noticeId,
          title: typeName + '|' + subTypeName,
          time,
          symbol: this.symbol
        }
      })
    },
    initVisited() {
      const list = JSON.parse(localStorage.getItem('announcement_visited') ?? '[]')
      // 避免数量无限增大
      if (list.length > 100) list.length = 100
      this.visitedAnnouncement = list
    },
    saveVisited(id) {
      this.visitedAnnouncement.unshift(id)
      localStorage.setItem('announcement_visited', JSON.stringify([...new Set(this.visitedAnnouncement)]))
    }
  }
}
</script>

<style lang="scss" scoped>
.announcement-wrapper {
  background: var(--bg-color-2);
}
</style>
